<!-- <mat-chip-list *ngIf="redirectEntries.length">
  <ng-container *ngFor="let entry of redirectEntries" >
    <div>
      <mat-icon style="vertical-align: middle; margin: 0 4px;">arrow_forward</mat-icon>
    </div>
    <mat-chip style="margin-bottom: 4px;" (click)="selectedRedirEntry = entry">
      {{entry.phonenumber | phoneNumberFormatter}}
      <ng-container *ngIf="entry.name">({{entry.name}})</ng-container>
      <mat-icon [ngClass]="entry.cssClass" class="redirect-icon" matTooltip="{{entry.getCallCauseString() | translate}}">{{entry.icon}}</mat-icon>
    </mat-chip>
  </ng-container>
</mat-chip-list> -->

<mat-list *ngIf="redirectEntries.length">
  <ng-container *ngFor="let entry of redirectEntries, let i = index">
    <div class="redirect" style="margin-bottom: 4px;" (click)="selectedRedirectEntry = entry" fxLayout="row">
      <div fxFlex>
        <mat-icon [ngClass]="entry.cssClass" class="redirect-icon" style="vertical-align: middle; margin: 0 4px;"
          matTooltip="{{entry.getCallCauseString() | translate}}">{{entry.icon}}</mat-icon>
        <div fxFlex>{{entry.name}}</div>
      </div>
      <div fxFlex="10" *ngIf="i !== (redirectEntries.length-1)">
        <mat-icon style="vertical-align: middle; margin: 0 4px;">
          arrow_forward</mat-icon>
      </div>
      <div fxFlex></div>
      <div fxFlex="10" *ngIf="i === (redirectEntries.length-1)"></div>
    </div>
  </ng-container>
</mat-list>
